import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { C } from '../tokens';
import Icon from '../components/Icon';

/* ─── Brand asterisk SVG from reference ─── */
function BrandSVG({ size = 32, color = '#fff' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.0799 24L4 19.2479L9.95537 8.75216L18.04 13.4961L18.0446 4H29.9554L29.96 13.4961L38.0446 8.75216L44 19.2479L35.92 24L44 28.7521L38.0446 39.2479L29.96 34.5039L29.9554 44H18.0446L18.04 34.5039L9.95537 39.2479L4 28.7521L12.0799 24Z" fill={color} />
    </svg>
  );
}

function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 48 48">
      <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
      <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
      <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
      <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
    </svg>
  );
}

function MicrosoftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 23 23">
      <path fill="#f35325" d="M1 1h10v10H1z" /><path fill="#81bc06" d="M12 1h10v10H12z" />
      <path fill="#05a6f0" d="M1 12h10v10H1z" /><path fill="#ffba08" d="M12 12h10v10H12z" />
    </svg>
  );
}

const inputStyle = {
  width: '100%', padding: '13px 16px', borderRadius: 12,
  border: '1px solid #e2e8f0', background: '#fff', fontSize: 14,
  outline: 'none', color: '#0f172a', transition: 'border-color .2s, box-shadow .2s',
};
const focusIn = (e) => { e.target.style.borderColor = C.primary; e.target.style.boxShadow = `0 0 0 3px ${C.primary}20`; };
const focusOut = (e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; };

export default function LoginPage() {
  const [showPw, setShowPw] = useState(false);
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: "'Public Sans','Inter',sans-serif" }}>
      {/* ═══ LEFT: Brand Sidebar ═══ */}
      <div className="login-sidebar" style={{ width: '50%', background: '#181111', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, opacity: .4, background: `radial-gradient(circle at center, ${C.primary}30, transparent 70%)` }} />
        <div style={{ position: 'absolute', bottom: '-10%', right: '-10%', width: '66%', height: '66%', background: C.primary, borderRadius: '50%', filter: 'blur(120px)', opacity: .2 }} />

        <div style={{ position: 'relative', zIndex: 1, padding: 48, maxWidth: 520 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 48 }}>
            <div style={{ background: C.primary, padding: 8, borderRadius: 10, display: 'grid', placeItems: 'center' }}>
              <BrandSVG size={32} />
            </div>
            <h1 style={{ fontSize: 28, fontWeight: 700, color: '#fff', letterSpacing: '-.02em' }}>
              Nieramind<span style={{ color: C.primary }}>.AI</span>
            </h1>
          </div>

          <h2 style={{ fontSize: 38, fontWeight: 700, color: '#fff', lineHeight: 1.15, marginBottom: 24, letterSpacing: '-.02em' }}>
            Empowering enterprise intelligence with Neural Logic.
          </h2>
          <p style={{ fontSize: 17, color: '#94a3b8', lineHeight: 1.7 }}>
            Access the next generation of AI-powered workspaces. Secure, scalable, and built for modern teams.
          </p>

          <div style={{ marginTop: 48, display: 'flex', flexDirection: 'column', gap: 24 }}>
            {[
              ['verified_user', 'Enterprise Grade Security', 'SOC2 Type II compliant infrastructure.'],
              ['speed', 'High-Performance Compute', 'Low latency inference across 40+ regions.'],
            ].map(([ic, t, d]) => (
              <div key={ic} style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                <Icon name={ic} size={24} style={{ color: C.primary, marginTop: 2, flexShrink: 0 }} />
                <div>
                  <div style={{ color: '#fff', fontWeight: 600, fontSize: 15 }}>{t}</div>
                  <div style={{ color: '#94a3b8', fontSize: 13, marginTop: 2 }}>{d}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ═══ RIGHT: Login Form ═══ */}
      <div className="login-form-area" style={{ width: '50%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 48px', background: C.bg }}>
        <div className="login-mobile-logo" style={{ display: 'none', marginBottom: 40, alignItems: 'center', gap: 8, justifyContent: 'center' }}>
          <Icon name="psychology" size={28} style={{ color: C.primary }} />
          <span style={{ fontSize: 22, fontWeight: 700 }}>Nieramind<span style={{ color: C.primary }}>.AI</span></span>
        </div>

        <div style={{ width: '100%', maxWidth: 480 }}>
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <h2 style={{ fontSize: 30, fontWeight: 700, color: '#0f172a', marginBottom: 12 }}>Welcome back</h2>
            <p style={{ color: '#64748b', fontSize: 15 }}>Enter your credentials to access your workspace</p>
          </div>

          {/* Social */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 32 }}>
            {[[<GoogleIcon key="g" />, 'Google'], [<MicrosoftIcon key="m" />, 'Microsoft']].map(([icon, label]) => (
              <button key={label} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '11px 16px', borderRadius: 12, border: '1px solid #e2e8f0', background: '#fff', fontSize: 14, fontWeight: 500, cursor: 'pointer', transition: 'background .15s' }}
                onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'} onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                {icon}<span>{label}</span>
              </button>
            ))}
          </div>

          {/* Divider */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 32 }}>
            <div style={{ flex: 1, height: 1, background: '#e2e8f0' }} />
            <span style={{ fontSize: 11, fontWeight: 500, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.12em', whiteSpace: 'nowrap' }}>Or continue with email</span>
            <div style={{ flex: 1, height: 1, background: '#e2e8f0' }} />
          </div>

          {/* Form */}
          <form onSubmit={e => { e.preventDefault(); navigate('/'); }} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 8 }}>Email Address</label>
              <input type="email" placeholder="name@company.com" style={inputStyle} onFocus={focusIn} onBlur={focusOut} />
            </div>

            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#475569' }}>Password</label>
                <Link to="/forgot-password" style={{ fontSize: 12, fontWeight: 600, color: C.primary, textDecoration: 'none' }}>Forgot Password?</Link>
              </div>
              <div style={{ position: 'relative' }}>
                <input type={showPw ? 'text' : 'password'} placeholder="••••••••" style={inputStyle} onFocus={focusIn} onBlur={focusOut} />
                <button type="button" onClick={() => setShowPw(p => !p)} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'none', cursor: 'pointer', color: '#94a3b8', display: 'grid', placeItems: 'center' }}>
                  <Icon name={showPw ? 'visibility_off' : 'visibility'} size={20} />
                </button>
              </div>
            </div>

            <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
              <input type="checkbox" style={{ width: 16, height: 16, accentColor: C.primary }} />
              <span style={{ fontSize: 14, fontWeight: 500, color: '#475569' }}>Remember me for 30 days</span>
            </label>

            <button type="submit" style={{ width: '100%', padding: '14px 0', borderRadius: 12, border: 'none', background: C.primary, color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer', boxShadow: `0 8px 24px ${C.primary}33`, transition: 'transform .1s' }}
              onMouseDown={e => e.currentTarget.style.transform = 'scale(.98)'} onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}>
              Sign In
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: 32, fontSize: 14, color: '#475569' }}>
            Don't have an account?{' '}
            <Link to="/register" style={{ color: C.primary, fontWeight: 700, textDecoration: 'none' }}>Create an account</Link>
          </p>
        </div>

        <div style={{ marginTop: 'auto', paddingTop: 40, display: 'flex', gap: 24 }}>
          {['Privacy Policy', 'Terms of Service', 'Help Center'].map(l => (
            <a key={l} href="#/" style={{ fontSize: 12, color: '#94a3b8', textDecoration: 'none' }}>{l}</a>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 1023px) {
          .login-sidebar { display: none !important; }
          .login-form-area { width: 100% !important; }
          .login-mobile-logo { display: flex !important; }
        }
      `}</style>
    </div>
  );
}
